import * as React from 'react'

import { Omit } from '../utils/types'
import { Autofocus } from '../effects/Autofocus'
import { OverlayTriggerNext } from './OverlayTriggerNext'
import {
  OverlayTriggerProps,
  OverlayTriggerPlacement,
} from '../state/OverlayTrigger'
import { wrapPromise } from '../state/DelayedCallback'

const ForwardPropsContainer = React.forwardRef(
  ({ children, container, className, ...props }: any, ref) => {
    const Container = container || 'div'

    return (
      <Container ref={ref} className={className}>
        {React.cloneElement(children, props)}
      </Container>
    )
  }
)

export const OverlayTriggerAdapter = React.forwardRef<
  HTMLElement,
  Omit<OverlayTriggerProps, 'overlay'> & {
    placement: OverlayTriggerPlacement
    overlay: React.ReactElement
  }
>(
  (
    {
      overlay,
      autoFocus,
      container,
      onVisibleChange,
      containerClass,
      ...props
    },
    ref
  ) => {
    const beforeHide = onVisibleChange
      ? (event: Event) => wrapPromise(onVisibleChange(false, event))
      : () => true

    const beforeShow = onVisibleChange
      ? (event: Event) => wrapPromise(onVisibleChange(true, event))
      : () => true

    return (
      <OverlayTriggerNext
        {...props}
        ref={ref}
        beforeHide={beforeHide}
        beforeShow={beforeShow}
        overlay={
          <ForwardPropsContainer
            container={container}
            className={containerClass}
          >
            <Autofocus enabled={autoFocus}>{overlay}</Autofocus>
          </ForwardPropsContainer>
        }
      />
    )
  }
)
